export type BatchDeleteSeriesRequestBody = {
  id: string;
};
